import IEventSession from "../interfaces/IEventSession";
import ISessionReservation from "../interfaces/ISessionReservation";
import APIService from "./API.service";
const queryString = require("query-string");

class SessionService extends APIService {
  // Get event sessions
  getSessions(eventId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };

    return this.call.get(
      `${this.apiUrl}/eventsessions?${queryString.stringify(query)}`
    );
  }

  // Search the sessions of the event
  searchSession(eventId: number, search: string) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
      search,
    };

    return this.call.get(
      `${this.apiUrl}/eventsessions/search?${queryString.stringify(query)}`
    );
  }

  // Get event session
  getSession(thirdPartyId: number): Promise<IEventSession> {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };

    return this.call.get(
      `${this.apiUrl}/eventsessions/${thirdPartyId}?${queryString.stringify(
        query
      )}`
    );
  }

  // Create event session
  createSession(eventId: number, params: any): Promise<IEventSession> {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };
    return this.call.post(
      `${this.apiUrl}/eventsessions?${queryString.stringify(query)}`,
      JSON.stringify(params)
    );
  }

  // Update event session
  updateSession(sessionId: number, params: any): Promise<IEventSession> {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.put(
      `${this.apiUrl}/eventsessions/${sessionId}?${queryString.stringify(
        query
      )}`,
      JSON.stringify(params)
    );
  }

  // Delete event session
  delete(sessionId: number) {
    const token = localStorage.getItem("fielddrive-token");
    return this.call.delete(
      `${this.apiUrl}/eventsessions/${sessionId}?token=${token}`
    );
  }

  // Delete all sessions
  deleteAll(eventId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };
    return this.call.delete(
      `${this.apiUrl}/eventsessions/?${queryString.stringify(query)}`
    );
  }

  // Import event sessions from csv file
  processEventSessionsCSV(eventId: number, filePath: string, fieldsMatch: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };
    const body = {
      filePath,
      fieldsMatch
    };
    return this.call.post(
      `${
        this.apiUrl
      }/eventsessions/processEventSessionsCSV?${queryString.stringify(query)}`,
      body
    );
  }

  // Import session reservations from csv file
  processSessionReservationsCSV(
    eventId: number,
    eventSessionId: string,
    filePath: string,
    fieldsMatch: any
  ) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
      eventSessionId,
    };
    const body = {
      filePath,
      fieldsMatch
    };
    return this.call.post(
      `${
        this.apiUrl
      }/eventsessions/processEventSessionReservationsCSV?${queryString.stringify(
        query
      )}`,
      body
    );
  }

  // Get the session reservations of a specific event session
  getSessionReservations(sessionId: number, eventId: number): Promise<ISessionReservation[]> {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };

    return this.call.get(
      `${
        this.apiUrl
      }/eventsessions/${sessionId}/sessionReservations?${queryString.stringify(
        query
      )}`
    );
  }
}

export default SessionService;
